import { useContext } from 'react';
import { useQuery } from 'react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import {
  getCXWorkspacesAtAccountLevel,
  getCXWorkspacesAtUserLevel,
} from 'services/CXWorkspaces/CXWorkspacesService';
import {
  UserContext,
  actionTypes,
} from 'containers/pages/ManageUsers/usersContext';
import { GlobalStoreInterface } from 'interface/globalStore';

const ACCOUNT_LEVEL_QUERY_KEY = 'accountLevelCxWorkspaces';
const USER_LEVEL_QUERY_KEY = 'userLevelCxWorkspaces';

export const useGetCXWorkspacesAtAccountLevel = () => {
  const { dispatch } = useContext(UserContext);

  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useQuery(
    [ACCOUNT_LEVEL_QUERY_KEY],
    () => getCXWorkspacesAtAccountLevel(sso, corpAccountNumber),
    {
      enabled: Boolean(sso && corpAccountNumber),
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (response) => {
        dispatch({
          type: actionTypes.POPULATE_ACCOUNT_LEVEL_CX_WORKSPACES,
          payload: [...response?.data?.profiles],
        });
      },
    },
  );
};

export const useGetCXWorkspacesAtUserLevel = (
  userUuid: string,
  didUserInitiallyHaveCXLicense: boolean,
) => {
  const { dispatch } = useContext(UserContext);

  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );

  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useQuery(
    [USER_LEVEL_QUERY_KEY, userUuid],
    () => getCXWorkspacesAtUserLevel(sso, corpAccountNumber, userUuid),
    {
      enabled: Boolean(
        sso && corpAccountNumber && userUuid && didUserInitiallyHaveCXLicense,
      ),
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (response) => {
        dispatch({
          type: actionTypes.POPULATE_ORIGINAL_USER_LEVEL_CX_WORKSPACES,
          payload: [...response?.data?.profiles],
        });
        dispatch({
          type: actionTypes.POPULATE_UPDATED_USER_LEVEL_CX_WORKSPACES,
          payload: [...response?.data?.profiles],
        });
      },
    },
  );
};
